export const AdditionalNavItemToken = Symbol.for('AdditionalNavItem');
